import React, { Component } from "react";

// reactstrap components
import {
    Card,
    CardTitle,
    CardHeader,
    CardBody,
    Row,
    Col,
    Table,
    Nav,
    NavItem,
    NavLink,
    TabContent,
    TabPane,
    Input,
    InputGroup,
    InputGroupAddon,
    InputGroupText
} from "reactstrap";


// core components
import PanelHeader from "components/PanelHeader/PanelHeader.js";
import image from "Main_Image.jpg";
import axios from "axios";
import { api_link } from "siteConfig";

class OutstandingQuotes extends Component {
    constructor(props) {
        super(props);

        this.state = {
            quoteOutstanding_visible: true,
            quoteDetails_visible: false,
            hTabs: "ht_outstanding_quotes",
            siteOutstandingQuotes: [],
            quoteDetails: [],
            searchTerm: ''
        };
    }

    async componentDidMount() {
        this.loadSiteOutstandingQuotes();
    }

    loadSiteOutstandingQuotesData = async () => {

        let url = 'https://' + api_link + 'customer_portal_v2/getOutstandingQuotes';
        let sites = sessionStorage.getItem("site_ids");

        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": sites
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadSiteOutstandingQuotes = async () => {
        const siteOutstandingQuotesData = await this.loadSiteOutstandingQuotesData();
        this.setState({ siteOutstandingQuotes: siteOutstandingQuotesData });
    }

    loadQuoteData = async (quote) => {
        let url = 'https://' + api_link + 'customer_portal_v2/getQuote';

        try {
            const response = await axios({
                method: "post",
                url: url,
                data: {
                    "referurl": url,
                    "var1": quote
                },
                timeout: 5000,
                headers: {
                    "api-key": "ad8acb-e20326-93d0b2-11e5f2-d78c2e",
                    "Content-Type": "application/json"
                }
            });
            return response.data;
        } catch (error) {
            // Handle any errors that occur during the API request
        }
    }

    loadQuote = async (quoteId) => {
        const quoteData = await this.loadQuoteData(quoteId);
        this.setState({ quoteDetails: quoteData });
    }

    sethTabs = (hTabs) => {
        this.setState({ hTabs });
        switch (hTabs) {
            case "ht_outstanding_quotes":
                this.setState({ quoteDetails_visible: false, quoteDetails: [] });
                break;
            case "ht_quote_details":
                // this.setState({ quoteDetails: [] });
                // this.loadQuote('76461');
                break;
            default:
                break;
        }
    };

    handleQuoteRowClick = (quoteId) => {
        this.loadQuote(quoteId);
        this.setState({ hTabs: "ht_quote_details" });
        this.setState({ quoteDetails_visible: true });
        
        // Scroll to the top of quote details for better UX
        setTimeout(() => {
            // Find the content div which uses Perfect Scrollbar
            const contentDiv = document.querySelector('.content');
            const mainPanel = document.querySelector('.main-panel');
            
            if (mainPanel && mainPanel.scrollTop !== undefined) {
                // If main-panel has scrollTop property, use it
                mainPanel.scrollTop = 0;
            } else if (contentDiv) {
                // Try to find Perfect Scrollbar instance
                if (contentDiv.scrollTop !== undefined) {
                    contentDiv.scrollTop = 0;
                }
                
                // Also try to reset Perfect Scrollbar if it exists
                const psRail = document.querySelector('.ps__rail-y .ps__thumb-y');
                if (psRail) {
                    psRail.style.top = '0px';
                }
                
                // If Perfect Scrollbar library is available globally
                if (window.PerfectScrollbar || window.Ps) {
                    const ps = window.PerfectScrollbar || window.Ps;
                    if (ps.update) {
                        ps.update(mainPanel || contentDiv);
                    }
                }
            } else {
                // Fallback: scroll the window
                window.scrollTo({
                    top: 0,
                    behavior: 'smooth'
                });
            }
        }, 100); // Small delay to ensure DOM updates
    }

    render() {

        return (
            <>
                <PanelHeader
                    size="lg"
                    content={image}
                />
                <div className="content" style={{ marginTop: '-270px' }}>
                    <Row>
                        <Col xs={12} md={12}>
                            <Card className="card-chart">
                                <CardHeader>
                                    <CardTitle tag="h4">Outstanding Quotes</CardTitle>
                                </CardHeader>
                                <CardBody>
                                    <InputGroup className="no-border" style={this.state.quoteDetails_visible ? { display: 'none' } : { display: '' }}>
                                        <Input style={{ color: 'black' }} placeholder="Search..." onChange={(e) => this.setState({ searchTerm: e.target.value })} />
                                        <InputGroupAddon addonType="append">
                                            <InputGroupText>
                                                <i className="now-ui-icons ui-1_zoom-bold" />
                                            </InputGroupText>
                                        </InputGroupAddon>
                                    </InputGroup>

                                    {/*START - Tab Navigation*/}
                                    <center>
                                        <Nav pills className="nav-pills-primary">
                                            <NavItem>
                                                <NavLink style={this.state.quoteDetails.length > 0 ? { display: '' } : { display: 'none' }} className={this.state.hTabs === "ht_outstanding_quotes" ? "active" : ""} onClick={() => this.sethTabs("ht_outstanding_quotes")} >
                                                    Quote List
                                                </NavLink>
                                            </NavItem>
                                            <NavItem style={this.state.quoteDetails_visible ? { display: '' } : { display: 'none' }}>
                                                <NavLink className={this.state.hTabs === "ht_quote_details" ? "active" : ""} onClick={() => this.sethTabs("ht_quote_details")} >
                                                    Quote Details
                                                </NavLink>
                                            </NavItem>
                                        </Nav>
                                    </center>
                                    {/*END - Tab Navigation*/}


                                    {/*START - Tab Content*/}
                                    <TabContent activeTab={this.state.hTabs}>


                                        {/*START - Tab Content - Outstanding Quotes*/}
                                        <TabPane tabId="ht_outstanding_quotes">
                                            <br />
                                            {this.state.siteOutstandingQuotes && this.state.siteOutstandingQuotes.length > 0 ? (
                                                <Table>
                                                    <tbody>
                                                        <tr>
                                                            <td>Quote Ref</td>
                                                            <td>Date Logged</td>
                                                            <td>Site ID</td>
                                                            <td>Site Name</td>
                                                            <td>Description</td>
                                                            <td>Priority</td>
                                                            <td>Total Price</td>
                                                        </tr>
                                                        {this.state.siteOutstandingQuotes.filter((quote) =>
                                                            ((quote.quote_ref && quote.quote_ref.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                                                            || (quote.site_alpha && quote.site_alpha.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                                                            || (quote.site_name && quote.site_name.toLowerCase().includes(this.state.searchTerm.toLowerCase()))
                                                        ))
                                                        .map((quote) => (
                                                            <tr onClick={() => this.handleQuoteRowClick(quote.id)} key={quote.id}>
                                                                <td>{quote.quote_ref}</td>
                                                                <td>{quote.submitted_to_customer ? new Date(quote.submitted_to_customer).toLocaleDateString("en-GB") : ""}</td>
                                                                <td>{quote.site_alpha}</td>
                                                                <td>{quote.site_name}</td>
                                                                <td>{quote.description}</td>
                                                                <td>{quote.priority}</td>
                                                                <td>£{quote.total_value}</td>
                                                            </tr>
                                                        ))}
                                                    </tbody>
                                                </Table>
                                            ) : (
                                                <p>No results</p>
                                            )}
                                        </TabPane>
                                        {/*END - Tab Content - Outstanding Quotes*/}


                                        {/*START - Tab Content - Quote Details*/}
                                        <TabPane tabId="ht_quote_details">
                                            <Table>
                                                {this.state.quoteDetails.map((quote, index) => (
                                                    <tbody key={index}>
                                                        <tr>
                                                            <td style={{ width: '300px' }}>Quote Ref</td>
                                                            <td>{quote.quote_ref}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Submitted To Customer</td>
                                                            <td>{new Date(quote.submitted_to_customer).toLocaleDateString("en-GB")}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Site</td>
                                                            <td>{quote.site_name}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Work Type</td>
                                                            <td>{quote.work_type}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Quote Status</td>
                                                            <td>{quote.quote_status}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Priority</td>
                                                            <td>{quote.priority}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Total Price</td>
                                                            <td>£{quote.total_value}</td>
                                                        </tr>
                                                        <tr>
                                                            <td>Fault Location</td>
                                                            <td>{quote.fault_location}</td>
                                                        </tr>
                                                        <tr>
                                                            <td style={{ verticalAlign: 'top' }}>Fault Description</td>
                                                            <td style={{ whiteSpace: 'pre-line', backgroundColor: '#f5f5f5' }}>{quote.description}</td>
                                                        </tr>
                                                    </tbody>
                                                ))}
                                            </Table>
                                        </TabPane>
                                        {/*END - Tab Content - Quote Details*/}


                                    </TabContent>
                                    {/*END - Tab Content*/}


                                </CardBody>
                            </Card>
                        </Col>
                    </Row>
                </div>
            </>
        );
    }
}

export default OutstandingQuotes;